<template>
  <picture class="img-fluid">
    <source v-if="logoWebp" :srcset="logoWebp" type="image/webp" />
    <img
      :src="logoPng"
      :alt="$t('App.OrgName')"
      :title="$t('App.OrgName')"
      :style="{ height, width: 'auto' }"
    />
  </picture>
</template>

<script>
import { computed } from "@vue/composition-api"; // Import Composition API functions

import gmpPng from "@/assets/logo/gmp/white.png";
import gmpWebp from "@/assets/logo/gmp/white.webp";

import mwmccPng from "@/assets/logo/mwmcc/white.png";
import mwmccWebp from "@/assets/logo/mwmcc/white.webp";

import launchitHealthPng from "@/assets/logo/launchithealth/white.png";

import { IS_GMP } from "../globals";
import { branding } from "@/utils/branding";

export default {
  props: {
    height: {
      type: String,
      default: "50px",
    },
  },
  setup(props) {
    const isGmp = computed(() => IS_GMP);

    const isLaunchitHealth = computed(() => branding.brand === "launchithealth");

    const logoPng = computed(() =>
      isLaunchitHealth.value ? launchitHealthPng : isGmp.value ? gmpPng : mwmccPng
    );
    const logoWebp = computed(() =>
      isLaunchitHealth.value ? null : isGmp.value ? gmpWebp : mwmccWebp
    );

    return { logoPng, logoWebp };
  },
};
</script>
